import { Link } from 'gatsby'
import React, { useContext } from 'react'

import { ThemeToggler, CustomLink } from '@/components'
import { themes } from '@/consts'
import { ThemeContext, LayoutContext, toggleLayout } from '@/context'
import { ArrowUpIcon } from '@/icons'
import { Image } from '@/uikit'

export const MobileMenu: React.FC<GatsbyTypes.HeaderFragment> = ({
    links,
    logo,
    logo_dark_mode,
    accent_mobile,
    accent_mobile_dark_mode,
    alternative_logo_text,
    alternative_accent_text,
}) => {
    const {
        state: { theme },
    } = useContext(ThemeContext)
    const { state, dispatch } = useContext(LayoutContext)

    return (
        <nav
            className={`${
                state.mobileMenu ? ' flex ' : ' hidden '
            } " pt-6.2 pl-1.5 pr-5 fixed top-0 bg-white w-full h-screen flex-col dark:bg-body-bg1-dm z-30 "`}
        >
            <div className="flex justify-between h-auto z-10 pl-3.5">
                <Link to="/">
                    <Image src={theme === themes.dark ? logo_dark_mode : logo} alt={alternative_logo_text || ''} />
                </Link>
                <button onClick={() => dispatch(toggleLayout())} className="focus:outline-none" type="button">
                    <ArrowUpIcon />
                </button>
            </div>
            <div className="overflow-y-auto z-10 relative">
                <ul className="flex flex-col pt-16 z-10 pl-5 ">
                    {links &&
                        links.map((link) => (
                            <li className="my-4.5" key={link.title}>
                                <CustomLink
                                    url={`/${link.url}`}
                                    type={link.type}
                                    newTab={link.new_tab || false}
                                    activeClassName="inline-block border-b-2 border-accent pb-1"
                                >
                                    <p className=" font-ilisarniq font-normal text-2xl text-text tracking-wide dark:text-gray-darker">
                                        {link?.title}
                                    </p>
                                </CustomLink>
                            </li>
                        ))}
                </ul>
                <div className="flex justify-start items-center z-10 mt-12 pl-6 mb-28">
                    <ThemeToggler id="toggle-mobile-menu" />
                </div>
            </div>
            <div className="absolute -bottom-7 right-0 z-0">
                <Image
                    src={theme === themes.dark ? accent_mobile_dark_mode : accent_mobile}
                    alt={alternative_accent_text || ''}
                />
            </div>
        </nav>
    )
}
